import { Card, CardContent, Grid, Typography, WithStyles, withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MyPATTextArea, MyPATTextField } from '../../../common';

import { SEO as SEOInterface } from '../../types/interfaces/AdvancedSettings';
import { courseStyles } from "../../styles";
import { TabVisited } from '../../types/interfaces/TabVisited';

interface Props extends WithStyles<typeof courseStyles> {
  seo: SEOInterface;
  handleSEO: (SEO: SEOInterface) => void;
  checkFormErrors: (formErrors: any) => void;
  isPreview: boolean;
  disableFields: boolean;
  tabVisited: TabVisited;
  setTabVisited: Function;
  isPublishBtnClicked: boolean;
  checkSeoMandatoryFields: Function;
}

interface State {
  // seo: SEOInterface;
  formErrors: any
}

class SEO extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // const { defaultValues } = this.props;
    // this.state = {
    //   seo: defaultValues,
    // };
    this.state = {
      formErrors: {
        title: '',
        description: '',
        keywords: ''
      }
    }
  }

  componentDidMount() {
    console.log('::::::SEO - isPreview:::::', this.props.isPreview)
    console.log('::::::::SEO DATA::::::::;', this.props.seo)
    this.props.checkFormErrors(this.state.formErrors);
    this.props.setTabVisited('seo')
    this.props.checkSeoMandatoryFields(this.props.seo)
  }

  handleChange = (e: any) => {
    const { name, value } = e.target;
    const { seo, seo: { metatags }, seo: { metatags: { title, keywords, description } } } = this.props;
    let updatedSeo = { ...seo };
    let updatedMetatags = { ...metatags };
    switch (name) {
      case 'title':
        updatedMetatags.title = value;
        updatedSeo.metatags = updatedMetatags;
        console.log(updatedSeo);
        this.checkFormErrors('title', value)
        break;
      case 'keywords':
        updatedMetatags.keywords = value;
        updatedSeo.metatags = updatedMetatags;
        this.checkFormErrors('keywords', value)
        break;
      case 'description':
        updatedMetatags.description = value;
        updatedSeo.metatags = updatedMetatags;
        this.checkFormErrors('description', value)
        break;
      default:
    }
    this.props.handleSEO(updatedSeo);
    this.props.checkSeoMandatoryFields(this.props.seo)
  }

  checkFormErrors = (name: string, data: string) => {
    const updatedFormErrors = { ...this.state.formErrors }
    switch (name) {
      case 'title':
        if (data.length === 0) { updatedFormErrors.title = 'Must enter title' }
        else { updatedFormErrors.title = ''; }
        break;
      case 'description':
        if (data.length === 0) { updatedFormErrors.description = 'Must enter description' }
        else { updatedFormErrors.description = ''; }
        break;
      case 'keywords':
        if (data.length === 0) {
          updatedFormErrors.keywords = 'Must enter keywords';
        }
        else {
          updatedFormErrors.keywords = ''
        }
        break;
      default:
    }
    this.setState({
      formErrors: updatedFormErrors
    }, () => console.log(this.state.formErrors))
    this.props.checkFormErrors(updatedFormErrors)
  }

  renderSEOFields = () => {
    const { classes, disableFields, isPreview, isPublishBtnClicked } = this.props;
    const { formErrors } = this.state;
    const {
      title,
      description,
      keywords
    } = formErrors
    return (
      <>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography className={[classes.labelTxt, classes.mb13].join(' ')}>
                  Course SEO<span>*</span>
                </Typography>
                <Grid container spacing={8}>
                  <Grid item xs={12}>
                    <Typography className={classes.labelNormal}>
                      Meta Title
                                </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.customTextArea}>
                    <MyPATTextArea
                      // className={classes.test}
                      fullWidthControl
                      multiline
                      inputId="title"
                      name="title"
                      placeholder="Enter Title"
                      disabled={disableFields || isPreview}
                      value={
                        this.props.seo
                        && this.props.seo.metatags
                        && this.props.seo.metatags.title}
                      onChange={(e: any) => this.handleChange(e)}
                      error={isPublishBtnClicked && title !== '' ? true : false}
                      errorText={title}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.labelNormal}>
                      Meta Keywords
                                </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.customTextArea}>
                    <MyPATTextArea
                      //   className={classes.inputWidth}
                      fullWidthControl
                      multiline
                      inputId="keywords"
                      name="keywords"
                      placeholder="Enter Keywords"
                      disabled={disableFields || isPreview}
                      value={this.props.seo.metatags.keywords}
                      onChange={(e: any) => this.handleChange(e)}
                      error={isPublishBtnClicked && keywords !== '' ? true : false}
                      errorText={keywords}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.labelNormal}>
                      Meta Description
                                </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.customTextArea}>
                    <MyPATTextArea
                      fullWidthControl
                      multiline
                      inputId="description"
                      name="description"
                      placeholder="Enter Description"
                      disabled={disableFields || isPreview}
                      value={this.props.seo.metatags.description}
                      onChange={(e: any) => this.handleChange(e)}
                      error={isPublishBtnClicked && description !== '' ? true : false}
                      errorText={description}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </>
    )
  }

  render() {
    return <>{this.renderSEOFields()}</>;
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(SEO));
